import { FC, useEffect, useState, MouseEvent, useRef } from 'react';
import { Button, Select, MenuItem, SelectChangeEvent, TextField, CircularProgress } from "@mui/material";
import StorylineServerProxy  from "../storyline-proxy/storyline-proxy";
import Customer from './customer';

export interface ReportGeneratorProps{
    loggedInUser: string,
}
  
export const ReportGenerator: FC<ReportGeneratorProps> = ({ loggedInUser }) =>  {

    let [users, setUsers] = useState([] as string[]);
    let [selectedUser, setSelectedUser] = useState(loggedInUser);
    let [signature, setSignature] = useState("<No email signature found>");
    let [customers, setCustomers] = useState([] as Customer[]);
    let [selectedCustomer, setSelectedCustomer] = useState("");

    let [firstDate, setFirstDate] = useState(new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000).toISOString().substring(0, 10));
    let [lastDate, setLastDate] = useState(new Date().toISOString().substring(0, 10));

    let [inProgress, setInProgress] = useState(false);

    useEffect(() => {
        StorylineServerProxy.getUsers().then((users) => {
            let usernames = ["all"];
            for(let user of users){
                if(user.roles.includes("FoxATM")){
                    usernames.push(user.username);
                    if(user.username == loggedInUser){
                        setSignature(user.emailSignature);
                    }                        
                }
            }
            setUsers(usernames);
            setSelectedUser(loggedInUser);
        })
    }, [loggedInUser]);

    useEffect(() => {
        StorylineServerProxy.getCustomers().then((customers) => {
            let allCustomers = customers;
            if(selectedUser == "all"){
                setCustomers(allCustomers);
                setSelectedCustomer(allCustomers[0].name);
            }
            else{
                let newCustomers: Customer[] = [];
                for(let customer of allCustomers){
                    if(customer.lead == selectedUser){
                        newCustomers.push(customer);
                    }
                }
                setCustomers(newCustomers);
                setSelectedCustomer(newCustomers[0].name);
            }
        })
    },[selectedUser]);

    useEffect(() => {
        StorylineServerProxy.getCustomers()?.then(customers => {
            for(const customer of customers){
                if(customer.name == selectedCustomer){
                const interval = customer.interval?customer.interval:7;
                    setFirstDate((new Date(new Date().getTime() - interval * 24 * 60 * 60 * 1000).toISOString().substring(0, 10)));
                    setLastDate((new Date(new Date().getTime()).toISOString().substring(0, 10)));
                }
            }
        })
    }, [selectedCustomer]);

    const handleUserChange = (event: SelectChangeEvent) => {
        setSelectedUser(event.target.value as string);
    };

    const handleCustomerChange = (event: SelectChangeEvent) => {
        setSelectedCustomer(event.target.value as string);
    };

    const generateEmail = (customer: Customer) => {
        let mailtoStringEncoded = encodeURI("mailto:" + customer.emails + 
        "?cc=" + customer.emailsCC + "&subject=" + customer.emailTitle + "&body=") + encodeURIComponent(customer.emailBody) + encodeURIComponent("\n") + encodeURIComponent(signature);
        window.open(mailtoStringEncoded);
    }

    const handleGenerateEmail = (event: MouseEvent) => {
        for(let customer of customers){
            if(customer.name == selectedCustomer){
                generateEmail(customer);
                break;
            }
        }
    }

    const handleGenerateAllEmails = () => {
        for(let customer of customers){
            generateEmail(customer);
        }
    }

    const handleGenerateAllReports = async () => {
        let fileName = await StorylineServerProxy.reportsForLead(selectedUser);
        window.open(new URL(StorylineServerProxy.getURLBase()).origin + "/reports/" + fileName.fileName);

    }

    const handleDownloadReport = async (event: MouseEvent) => {
        console.log("Will call for " + selectedCustomer + " " + firstDate + " " + lastDate);
        setInProgress(true);
        let fileName = await StorylineServerProxy.reportForCustomer(selectedCustomer, firstDate, lastDate);
        console.log(fileName);
        window.open(new URL(StorylineServerProxy.getURLBase()).origin + "/reports/" + fileName.fileName);
        setInProgress(false);
    }



    return (
        <>
            <Select onChange={ handleUserChange } value={ selectedUser }>
                { 
                    users.map((currentUser) => {
                        return <MenuItem value={currentUser}>{ currentUser }</MenuItem>
                    })
                }
            </Select>
            <Select onChange={ handleCustomerChange } value={ selectedCustomer }>
                { 
                    customers.map((customer) => {
                        return <MenuItem value={customer.name}>{ customer.name }</MenuItem>
                    })
                }
            </Select>
            <br/><br/>
            <TextField sx={{ width: 1/2 }} label={"First date"} value={firstDate} onChange={event => {setFirstDate(event.target.value)}}/>
            <TextField sx={{ width: 1/2 }} label={"Last date"} value={lastDate} onChange={event => {setLastDate(event.target.value)}}/>
            {
                inProgress?<CircularProgress/>:<Button onClick={handleDownloadReport}>Download report</Button>
            }
            <Button onClick={handleGenerateEmail}>Generate email</Button>
            <br/><br/>
            <Button onClick={handleGenerateAllReports}>Generate all reports</Button>
            <Button onClick={handleGenerateAllEmails}>Generate all emails</Button>
        </>
    )
}
  